import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faPhotoFilm,faSliders,faBolt,faCheck,faStar,faXmark, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faArrowRight,faBus, faMapLocationDot, faHotel, faMessage, faSquareArrowUpRight,faChevronDown, faMicrophone,faChevronUp, faBowlFood, faMountain} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin,} from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect}from 'react'
import PackageSlider from "./Component/PackageSlider";
import Bookingform from "./Component/bookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
   {
    title: "7 Unesco Heritage Tour",
    days: "8 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.webp",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Peak & Safaris",
    location: "Nepal",
    days: "6 Days",
    difficulty: "Easy",
    price: 1150,
    duration: "6 Days",
    image: "/img/capital/nagarkot.webp",
    link: "/kathmandu-chitwan-nagarkot"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 1600,
    duration: "10 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/company/airportdslr.jpeg",
  "/img/chitwan/chitwan1dslr.jpeg",
  "/img/chitwan/canoing.jpeg",
  "/img/chitwan/chitwan5dslr.jpeg",
  "/img/company/groupphoto.jpeg",
  "/img/chitwan/chitwan2dslr.jpeg",
  "/img/chitwan/chitwan4dslr.jpeg",
  "/img/company/me1dslr.jpeg",
  "/img/chitwan/chitwan7dslr.jpeg",
  "/img/chitwan/chitwan6dslr.jpeg",
  "/img/chitwan/chitwan8dslr.jpeg",
  "/img/chitwan/chitwandslr.jpeg",
  "/img/capital/pro.png",
  "/img/capital/swyambhunath1dslr.jpeg",
  "/img/capital/bouddha.webp",
  "/img/capital/pasupatinath.jpg",
  "/img/capital/image-asset.webp",
  "/img/capital/capitaldslr.jpeg",
  "/img/capital/kathmandu2.jpg",
  "/img/company/mewith.jpeg",
  "/img/company/medslr.jpeg",
  "/img/chitwan/lumbini.jpg",
];
const Allnepal = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [count,Setcount]=useState(1);
  const [day1Open, setDay1Open] = useState(false);
  const [day2Open, setDay2Open] = useState(false);
  const [day3Open, setDay3Open] = useState(false);
  const [day4Open, setDay4Open] = useState(false);
  const [day5Open, setDay5Open] = useState(false);
  const [day6Open, setDay6Open] = useState(false);
const [day7Open, setDay7Open] = useState(false);
const [day8Open, setDay8Open] = useState(false);
const [day9Open, setDay9Open] = useState(false);
const [day10Open, setDay10Open] = useState(false);
const [day11Open, setDay11Open] = useState(false);
const [day12Open, setDay12Open] = useState(false);
const [day13Open, setDay13Open] = useState(false);
const [day14Open, setDay14Open] = useState(false);
const [day15Open, setDay15Open] = useState(false);
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  const getmul=(qty)=>{
    if(qty===1)return 4200;
if(qty>=2 && qty<=5)return 4200;
if(qty>=6)return 4200;
    };
    const totalprice =count*getmul(count);
    const [opent, seT] = useState(false);
    const [opente, seTe] = useState(false);
    const [openr, seTr] = useState(false);
    const [openH, seTh] = useState(false);
    useEffect(()=>{
      if(opent){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[opent]);
    useEffect(()=>{
      if(openH){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[openH]);
    const [activeIndex, setActiveIndex] = useState(null);
    
      const toggleFaq = (index) => {
        if (activeIndex === index) {
          setActiveIndex(null);
        } else {
          setActiveIndex(index);
        }
      };
  return (
   <main>
    <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">All Nepal Tour</h1>

    <div className="breadcrumb">
    Kathmandu-Chitwan-Lumbini-Nagarkot-Ghandrukh-Dhampush + More <span>15 Days Tour</span>
    </div>
     <div className="everest-image">
        <div className="everest-full">
          <img src="/img/pokhara/pokharadslr.jpeg" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >  <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>
        </div>
        <div className="everest-half">
            <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
            <div className="image-box"> <img src="/img/chitwan/chitwan2dslr.jpeg" alt="error" /></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />
      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>15 Days</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>Whole Year</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Private Vehical</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Exploring Natural Beauty and Culture</p>
          </div>
        </div>

         <div className="grid-item" onClick={()=>seTh(true)}>
          <FontAwesomeIcon icon={faHotel}/>
          <div className="grid-item-next">
            <p className='Dur'>Hotel Included</p>
            <p className='Duration'>4 And 5 Star (Changeable)</p>
          </div>
        </div>
        <div className="grid-item">
          <FontAwesomeIcon icon={faBowlFood}/>
          <div className="grid-item-next">
            <p className='Dur'>Breakfast</p>
            <p className='Duration'>Included</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faMountain}/>
          <div className="grid-item-next">
            <p className='Dur'>Maximum Elevation</p>
            <p className='Duration'>2100 M</p>
          </div>
        </div>

      </div>

       </div>
   <div className="overview-container" id='overview'>
  <div className="heading">Highlights Of Tours</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Deep spiritual immersion at Pashupatinath, watching sacred Aarti rituals on the Bagmati River at dusk.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Morning kora with Tibetan monks at Boudhanath, one of the largest Buddhist stupas in the world.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Panoramic Himalayan sunrise from Nagarkot, spotting Mount Everest glowing gold on the horizon.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Heart-pounding jeep safari through Chitwan jungle, coming face-to-face with one-horned rhinos in the wild.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Walking the sacred grounds of Lumbini, the birthplace of Buddha, through the serene world monastery zone.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Stepping back into medieval Nepal at Bhaktapur Durbar Square, exploring the 55-Window Palace and Nyatapola Temple.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Tandem paragliding over Pokhara from Sarangkot, soaring above Phewa Lake with the full Annapurna range ahead.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Sunset over the Himalayas from Bandipur's car-free Newari hilltop bazaar, completely untouched by mass tourism.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Overnight homestay in Ghandruk village, dining by firelight with Annapurna South filling the window.</p>

<p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Standing at Dhampus at dawn with the entire Annapurna range — Machhapuchhre, Annapurna I to IV — stretched across the sky.</p>
  </div>
</div>
      <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
 Nepal is not just a destination — it is an experience that stays with you forever. This 
    <strong> 15-Day Nepal Grand Tour</strong> is carefully crafted to take you through every 
    dimension of this extraordinary country, from the ancient temple squares of the Kathmandu 
    Valley to the wild jungles of Chitwan, the sacred plains of Lumbini, the serene lake city 
    of Pokhara, and the breathtaking Annapurna foothills of Ghandruk and Dhampus.
  </div>

  <div className="heading smalling">Places You’ll Visit:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Lumbini Garden:</b> The sacred UNESCO site and birthplace of Siddhartha Gautama, the Buddha.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Chitwan National Park:</b> A world-class wildlife sanctuary famous for One-Horned Rhinos and vibrant birdlife.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Pashupatinath Temple:</b> Nepal's most significant Hindu temple, a center of devotion along the Bagmati River.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Maya Devi Temple:</b> The exact spot where Queen Maya Devi gave birth to the Enlightened One.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Patan Durbar Square:</b> A masterpiece of Newari architecture, renowned for its stone carvings and metalwork.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Boudhanath Stupa:</b> A massive dome of peace and the heart of Tibetan Buddhism in Nepal.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Rapti River:</b> A serene waterway perfect for canoeing and spotting crocodiles at sunset.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Tharu Village:</b> An authentic glimpse into the traditional lifestyle of the indigenous jungle people.</p>
  </div>

  <div className="heading smalling">Introduction Of Places</div>

  <p className='overview-text'><b>Spiritual Pilgrimage in Lumbini:</b> Walk through the sacred monastic zones where nations from across the globe have built stunning temples. Experience a sense of deep tranquility at the Ashoka Pillar and the eternal peace flame, reflecting on the origins of Buddhism.</p>
  
  <p className='overview-text'><b>Wild Terai Expedition:</b> Venture into the dense grasslands of Chitwan. Through thrilling Jeep safaris and peaceful river excursions, you will witness a thriving ecosystem that protects some of the planet's most endangered wildlife in their natural habitat.</p>
  
  <p className='overview-text'><b>The Living Heritage of Kathmandu:</b> Discover the "City of Temples" through its dual spiritual identity. Visit the golden spires of Pashupatinath and the massive mandala of Bouddhanath, witnessing centuries-old rituals that remain a vibrant part of daily life.</p>
  
  <p className='overview-text'><b>Riverside Serenity & Culture:</b> Glide down the Rapti River in a traditional hand-carved canoe as the sun sets. Later, immerse yourself in the energetic Tharu cultural dance, a rhythmic celebration of the indigenous people's connection to the forest.</p>
  
  <p className='overview-text'><b>Artistry of the Malla Era:</b> Explore the ancient city of Patan, where every corner reveals a hidden courtyard or an intricately carved window. This "City of Fine Arts" showcases the peak of medieval craftsmanship and Nepal's enduring artistic legacy.</p>

  <p className='overview-text'><b>Boudhanath: The Circle of Peace</b> Stand before the massive white dome and the watchful eyes of the Buddha. As you walk with the pilgrims in a clockwise circle, the smell of incense and the hum of "Om Mani Padme Hum" creates a meditative atmosphere that calms the busiest of minds.</p>

  <p className='overview-text'><b>Rapti River: The Jungle’s Mirror</b> Drift silently in a hand-carved canoe as the jungle wakes up. The river is a lifeline for crocodiles sunning on the banks and kingfishers diving for their morning catch. It is the most peaceful way to witness the raw beauty of Chitwan's ecosystem.</p>

  <p className='overview-text'><b>Tharu Village & Culture: Heart of the Terai</b> Meet the resilient Tharu people, whose culture is deeply intertwined with the jungle. Their traditional mud-walled houses and the rhythmic "Stick Dance" performed in the evenings tell a story of harmony between humans and the wild.</p>

  <p className='overview-text'><b>Swayambhunath: The Valley Sentinel</b> Perched atop a hill, this stupa is a mosaic of fluttering prayer flags and playful monkeys. It is the perfect place to watch the sun set over the sprawling city of Kathmandu, reflecting on a journey that spans from the depths of the jungle to the peaks of the sky.</p>
</div>
<div className="overview-container">
  <div className="overview-heading">Why This Package?</div>
  <p className='overview-text'>Exploring Nepal’s diverse landscapes—from crowded ancient cities to wild jungles—requires careful planning. Our 8-day "Classic Nepal" package is designed to give you a seamless experience across three distinct regions, ensuring you capture the true essence of the country without the logistical headaches.</p>
  
  <div className="heading smalling">The Ultimate Triple-Experience</div>
  <p className='overview-text'>Why settle for just one side of Nepal? This itinerary offers the perfect trifecta: the deep spirituality of Kathmandu’s temples, the raw wildlife adventure of Chitwan’s jungles, and the peaceful Himalayan reflections of Pokhara. It is the most comprehensive non-trekking tour available.</p>
  
  <div className="heading smalling">Adventure Without the Hardship</div>
  <p className='overview-text'>We bring you close to nature without requiring heavy gear or elite fitness. Whether it’s a jeep safari to spot rhinos or a private boat ride on Phewa Lake, every highlight is chosen for maximum beauty and comfort, making it ideal for families, couples, and seniors.</p>
  
  <div className="heading smalling">All-Inclusive Logistics</div>
  <p className='overview-text'>Navigating the roads between Kathmandu, Chitwan, and Pokhara can be tricky. We provide experienced drivers and comfortable private vehicles for all inter-city transfers, along with pre-booked premium accommodations, so your only job is to keep your camera ready.</p>
  
  <div className="heading smalling">Deep Cultural Immersion</div>
  <p className='overview-text'>Beyond the scenery, we connect you with the people. You’ll experience the unique traditions of the indigenous Tharu community in the south and the intricate Newari craftsmanship of the valley, guided by locals who share the stories that aren't found in guidebooks.</p>
  
  <div className="heading smalling">Unbeatable Value & Support</div>
  <p className='overview-text'>By combining safari, sightseeing, and relaxation into one fixed-price package, you get the best value for your time and money. Plus, with our 24/7 local support, you have a "friend in Nepal" ready to assist you at every turn of your journey.</p>
</div>
<div className="overview-container" >
<div className="overview-heading" id='itinerary'>ITINERARY</div>

  {/* Day 1-2 */}
  <div className="timeline-row">
    <div className="timeline-left"><div className="day-circle">D1</div></div>
    <div className="timeline-right" onClick={() => setDay1Open(!day1Open)}>
      <div className="timeline-title">Arrive Kathmandu</div>
      <div className="arrow-icon"><FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} /></div>
    </div>
  </div>
  {day1Open && <div className="timeline-detail">Land at Tribhuvan International Airport. Check in to your hotel in Thamel. Evening stroll through Thamel bazaar — buy a SIM card, exchange currency, try dal bhat at a local restaurant. Early night to beat jet lag.</div>}

  
  <div className="timeline-row time-linemargin">
    <div className="timeline-left"><div className="day-circle">D2</div></div>
    <div className="timeline-right" onClick={() => setDay2Open(!day2Open)}>
      <div className="timeline-title">Swayambhunath + Kathmandu Durbar Square + Pashupatinath</div>
      <div className="arrow-icon"><FontAwesomeIcon icon={day2Open ? faChevronUp : faChevronDown} /></div>
    </div>
  </div>
  {day2Open && <div className="timeline-detail">Start at sunrise on Swayambhunath hill (365 steps, 360° valley views, resident monkeys). Mid-morning explore Kathmandu Durbar Square and Hanuman Dhoka Palace. Afternoon at Pashupatinath for the sacred riverside Aarti ceremony at dusk.</div>}

  {/* Day 5 */}
  <div className="timeline-row time-linemargin">
    <div className="timeline-left"><div className="day-circle">D3</div></div>
    <div className="timeline-right" onClick={() => setDay3Open(!day3Open)}>
      <div className="timeline-title">Boudhanath + Patan Durbar Square</div>
      <div className="arrow-icon"><FontAwesomeIcon icon={day3Open ? faChevronUp : faChevronDown} /></div>
    </div>
  </div>
  {day3Open && <div className="timeline-detail">Morning kora (clockwise circumambulation) around Boudhanath Stupa with monks. Coffee from a rooftop café with the dome in full view. Afternoon in Patan — finer Newari wood carvings than Kathmandu itself. Don't miss the Patan Museum and Krishna Mandir.</div>}

  <div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D4</div></div>
  <div className="timeline-right" onClick={() => setDay4Open(!day4Open)}>
    <div className="timeline-title">Bhaktapur & Nagarkot Overnight</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day4Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day4Open && (
  <div className="timeline-detail">
    Full morning in Bhaktapur — Nepal's best-preserved medieval city. See the 55-Window Palace, Nyatapola Temple and Pottery Square. Try juju dhau (king curd) before leaving. Drive 30 minutes to Nagarkot in the afternoon and check in for a spectacular Himalayan sunset.
  </div>
)}

{/* Day 5 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D5</div></div>
  <div className="timeline-right" onClick={() => setDay5Open(!day5Open)}>
    <div className="timeline-title">Nagarkot Sunrise → Drive to Chitwan</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day5Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day5Open && (
  <div className="timeline-detail">
    Wake at 5:30 AM for the panoramic Himalayan sunrise — on clear days you can spot Mount Everest. Enjoy breakfast with the view. By 8 AM drive south (~4.5 hrs) to Chitwan. Arrive afternoon, check into jungle lodge. Evening Tharu cultural dance programme.
  </div>
)}

{/* Day 6 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D6</div></div>
  <div className="timeline-right" onClick={() => setDay6Open(!day6Open)}>
    <div className="timeline-title">Chitwan Full Wildlife Safari</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day6Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day6Open && (
  <div className="timeline-detail">
    5:30 AM jeep safari into the jungle — one-horned rhinos, Bengal tigers (if lucky), gharial crocodiles and over 600 bird species. Canoe ride on the Rapti River after lunch with crocodiles sunbathing on the banks. Evening visit to the elephant breeding centre.
  </div>
)}

{/* Day 7 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D7</div></div>
  <div className="timeline-right" onClick={() => setDay7Open(!day7Open)}>
    <div className="timeline-title">Birthplace of Buddha: Lumbini</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day7Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day7Open && (
  <div className="timeline-detail">
    Morning bird walk in Chitwan at dawn. Drive west (~3 hrs) to Lumbini. Visit Maya Devi Temple (exact birthplace of Buddha), the sacred Puskarini pond, Ashoka Pillar (249 BCE) and the world monastery zone where 30+ nations have built unique monasteries. Hire a bicycle to explore the full zone at sunset.
  </div>
)}

{/* Day 8 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D8</div></div>
  <div className="timeline-right" onClick={() => setDay8Open(!day8Open)}>
    <div className="timeline-title">Hidden Gem: Bandipur Hill Town</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day8Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day8Open && (
  <div className="timeline-detail">
    Drive northeast (~4 hrs) to Bandipur — a car-free Newari hilltop town most tourists completely miss. Explore the stone-paved bazaar, traditional architecture untouched since the 18th century and sweeping views of the Annapurna and Manaslu ranges. Visit Thani Mai Temple and Siddha Cave. Overnight in Bandipur for sunset over the Himalayas.
  </div>
)}

{/* Day 9 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D9</div></div>
  <div className="timeline-right" onClick={() => setDay9Open(!day9Open)}>
    <div className="timeline-title">Bandipur → Pokhara, the Lake City</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day9Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day9Open && (
  <div className="timeline-detail">
    Morning in Bandipur for sunrise views and local chiya (tea). Drive down to Pokhara (~2 hrs). Rent a rowboat on Phewa Lake and row to Tal Barahi Temple on the island. Evening at Lakeside with Annapurna's reflection shimmering on the water. Visit the International Mountain Museum.
  </div>
)}

{/* Day 10 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D10</div></div>
  <div className="timeline-right" onClick={() => setDay10Open(!day10Open)}>
    <div className="timeline-title">Sarangkot Sunrise & Pokhara Adventures</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day10Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day10Open && (
  <div className="timeline-detail">
    Pre-dawn drive to Sarangkot (1,600m) for Nepal's most iconic Himalayan sunrise — Annapurna, Machhapuchhre and Dhaulagiri glowing gold. Back by 8 AM for breakfast. Rest of the day: paragliding over Phewa Lake, zip-line, kayaking or the World Peace Pagoda hike.
  </div>
)}

{/* Day 11 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D11</div></div>
  <div className="timeline-right" onClick={() => setDay11Open(!day11Open)}>
    <div className="timeline-title">Pokhara Leisure & Begnas Lake</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day11Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day11Open && (
  <div className="timeline-detail">
    Relaxed morning at Lakeside. After breakfast drive 15 km east to Begnas Lake — far quieter than Phewa, with a local fishing village atmosphere and no tourist crowds. Afternoon options: Gupteshwor Cave (beneath Davis Falls), Tibetan Refugee Camp or cycling along the lakeside trail.
  </div>
)}

{/* Day 12 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D12</div></div>
  <div className="timeline-right" onClick={() => setDay12Open(!day12Open)}>
    <div className="timeline-title">Ghandruk Village, Annapurna Foothills</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day12Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day12Open && (
  <div className="timeline-detail">
    Drive from Pokhara to Naya Pul (~1.5 hrs), then jeep to Ghandruk village (~1 hr). Explore the stone-paved lanes of this classic Gurung village at 1,940m, visit the Gurung Museum and soak in jaw-dropping Annapurna South and Machhapuchhre views. Overnight in a traditional homestay with a dal bhat dinner by firelight.
  </div>
)}

{/* Day 13 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D13</div></div>
  <div className="timeline-right" onClick={() => setDay13Open(!day13Open)}>
    <div className="timeline-title">Ghandruk → Dhampus Village → Pokhara</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day13Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day13Open && (
  <div className="timeline-detail">
    Morning sunrise over Annapurna from Ghandruk. Jeep to Dhampus (Australian Camp area) — a quieter village at 1,650m with arguably the finest Annapurna range panorama accessible by road. Picnic lunch with mountain views. Drive back to Pokhara by late afternoon for a farewell lakeside dinner.
  </div>
)}

{/* Day 14 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D14</div></div>
  <div className="timeline-right" onClick={() => setDay14Open(!day14Open)}>
    <div className="timeline-title">Pokhara → Kathmandu</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day14Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day14Open && (
  <div className="timeline-detail">
    Morning flight to Kathmandu (25 min — sit on the right side for full Himalayan views) or scenic tourist bus along the Prithvi Highway beside the Trishuli River (~7 hrs). Afternoon: Ason Market for spices and local shopping, Indra Chowk, and a traditional Newari dinner to close the evening.
  </div>
)}

{/* Day 15 */}
<div className="timeline-row time-linemargin">
  <div className="timeline-left"><div className="day-circle">D15</div></div>
  <div className="timeline-right" onClick={() => setDay15Open(!day15Open)}>
    <div className="timeline-title">Final Morning: Boudhanath & Departure</div>
    <div className="arrow-icon"><FontAwesomeIcon icon={day15Open ? faChevronUp : faChevronDown} /></div>
  </div>
</div>
{day15Open && (
  <div className="timeline-detail">
    Early morning final kora at Boudhanath Stupa — the most peaceful time to visit with almost no crowds. Breakfast at a rooftop café overlooking the dome. Last-minute shopping in Thamel: thangka paintings, pashmina scarves, singing bowls and lokta paper goods. Transfer to Tribhuvan Airport for departure.
  </div>
)}
  
</div>
  {/* Cost Section */}
  <div className="overview-container width-hund" id='included'>
    <div className="cost-box included">
      <div className="cost-title">Cost Included</div>
      <div className="cost-item">
        <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
        <div className="cost-text">Private AC vehicle for all transfers and inter-city drives.</div>
      </div>
      <div className="cost-item">
        <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
        <div className="cost-text">Accommodation with breakfast in Kathmandu, Chitwan, and Lumbini.</div>
      </div>
      <div className="cost-item">
        <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
        <div className="cost-text">All jungle activities in Chitwan including national park entry fees.</div>
      </div>
    </div>

    <div className="cost-box excluded">
      <div className="cost-title">Cost Not Included</div>
      <div className="cost-item">
        <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
        <div className="cost-text">International flights and Nepal tourist visa fees.</div>
      </div>
      <div className="cost-item">
        <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
        <div className="cost-text">Lunch and dinner (except during the Chitwan jungle stay).</div>
      </div>
      <div className="cost-item">
        <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
        <div className="cost-text">Personal travel insurance and tips for guides/drivers.</div>
      </div>
    </div>
  </div>
<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> FAQS
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <div className="faq-question">
            Booking & Payment Terms
              <span>{activeIndex === 0 ? "-" : "+"}</span>
            </div>
            {activeIndex === 0 && (
              <div className="faq-answer">
               To confirm your trip, a 10% deposit is required at the time of booking. Upon your arrival in Nepal and transfer to your hotel, 70% of the total fee is due to begin the tour services. The remaining balance payment must be settled in full after the fourth day of your journey.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <div className="faq-question">
              How can I book a tour?
              <span>{activeIndex === 1 ? "-" : "+"}</span>
            </div>
            {activeIndex === 1 && (
              <div className="faq-answer">
                You can book directly from our website by clicking button  or contact our support team from right side contact details or from contact us page where is a QR for your ease scan and contactus.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
            This package is perfectly suited for first-time travelers and families looking for a comprehensive introduction to Nepal without the physical demands of high-altitude trekking. It balances the deep historical roots of the Kathmandu Valley’s ancient squares with the tranquil, natural beauty of Pokhara’s lakeside and caves. Because every destination is accessible by vehicle, it is an excellent choice for senior citizens, photographers, or time-constrained tourists who want to experience the "Golden Triangle" of Nepal’s heritage and Himalayan views in comfort and style.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies Cancel up to 6 days before in advance for a full refund after 6 days there will no refund of your 10% payment.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Travel Documents:</b> Ensure you have a valid passport and printed copies of your booking confirmation and insurance.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Comfortable Footwear:</b> Pack a pair of sturdy walking shoes or sneakers for navigating the stone pathways of Bhaktapur and the nature trails in Sarangkot.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Seasonal Layering:</b> Bring a warm jacket or fleece for the early morning sunrises in Nagarkot and Sarangkot, as temperatures drop significantly before dawn.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Personal Care:</b> Remember to pack sunscreen, sunglasses, and a hat to protect yourself from the strong high-altitude sun during your Phewa Lake boat ride.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Day Pack:</b> Use a small backpack to keep your camera, power bank, and rain gear handy for sudden mountain weather changes.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Currency & Cash:</b> Keep some local currency (NPR) for personal expenses, tips, and meals not included in the package.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
               <div className="heading smalling">Meal Plan Details</div>

<p className='overview-text'><b>Standard Inclusion:</b> Every morning begins with a fresh, delicious breakfast included at your hotel to fuel your day of exploration. This ensures you start your journey energized and ready for the sights ahead.</p>

<p className='overview-text'><b>Lunch & Dinner (Flexible):</b> To give you complete freedom over your palate, these meals are not included in the base price. Your guide will introduce you to top-rated local restaurants where you can pay directly, allowing you to discover the diverse flavors of Nepal at your own pace.</p>

<p className='overview-text'><b>Full-Board Upgrade (Recommended):</b> For those seeking a truly seamless and worry-free adventure, we can include all lunch and dinner charges in your package. We will handle all the arrangements and payments at every destination, so your only responsibility is to sit back, relax, and enjoy the trip.</p>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(8)}>
            <div className="faq-question">
              Do you offer group discounts?
              <span>{activeIndex === 8 ? "-" : "+"}</span>
            </div>
            {activeIndex === 8 && (
              <div className="faq-answer">
                When you see right side in desktop and little bit below in mobile screen we made a system where total price is calculated according to number of people and there may be available of more discount for group which is not mention in this system than our booking team will mention it while enquiry or booking.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a few hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable helicopter flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize" onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review" onClick={()=>seTr(true)}>
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>$4200</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>All Price Inclusive</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <p className='lt'><FontAwesomeIcon icon={faBolt}></FontAwesomeIcon>Price Decreases When Travellers Increases</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>1){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>${totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/Terms" className="download">
                
                  <h6>See Terms & Conditions</h6>
                </Link>
                <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
            src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
           <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
      <button onClick={()=>seT(true)}>Book Now</button>
      <button onClick={()=>seTe(true)}>Enquiry Now</button>
      </div>
     </section>
     {opent &&( 
      <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <Bookingform src="/img/chitwan/canoingdslr.jpeg" title="All Nepal Tour"/></section>
     )}
{opente &&( 
  <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/chitwan/canoingdslr.jpeg" title="All nepal Tour"/></section>
  
)}
{openr &&( 
  <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review /></section>
 
)}
   </main>
  )
}
export default Allnepal